import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
// import { Initialize as GA_Initialize } from './helpers/GoogleAnalytics';

const rootEl = document.getElementById('root');

// GA_Initialize();

ReactDOM.render(<App />, rootEl);

if (module.hot) {
  module.hot.accept('./App', () => {
    const NextApp = require('./App').default;
    ReactDOM.render(<NextApp />, rootEl);
  });
}
